<template>
    <div>
        <div
            class="d-flex flex-column mt-3"
            :class="prop_readonly ? 'align-items-left' : 'align-items-center'"
        >
            <!-- Common main element parameters-->
            <div v-if="!prop_readonly" class="text-left">
                <div
                    v-for="parameter in app.currentConfiguration
                        .commonMainElementParameters"
                    style="border: 0px solid black; background-color: white"
                    :key="parameter.attribute.id"
                    class="my-1 d-flex flex-row"
                >
                    <editParameterValueComponent
                        ref="editParameterValueComponent"
                        :labelOverInput="isMobile ? true : false"
                        :parameter="parameter"
                        :prop_title_show="true"
                        :value.sync="parameter.value"
                        :html_tooltip_info_dist_max_bandeja="
                            parameter.attribute.id === 'distancia_soportes'
                                ? true
                                : false
                        "
                        @update:value="refreshParameters"
                        @beforeUpdate:value="beforeUpdateParameter"
                        @afterUpdate:value="afterUpdateParameter"
                        :style_inside_dropdown="
                            'padding:4px !important; width: ' + width_params
                        "
                        :style_inside_textbox="'width:' + width_params"
                    ></editParameterValueComponent>
                </div>
            </div>

            <!-- distance info mesage -->
            <div v-if="!prop_readonly" class="my-1 d-flex flex-row">

                <!-- distance info mesage -->
                <div
                    class="alert"
                    v-if="!helper.isDistanceOk()"
                    :class="'alert-danger'"
                    role="alert"
                >
                    <p v-html="helper.getDistanceMessage()"></p>
                </div>
            </div>

            <!-- Elements: 2x5 GRID -->
            <div
                class="bandeja-66-grid d-flex flex-column mt-5"
                style="position: relative"
                :ref="'div_images_66_simetric'"
            >
                <!--  techo desktop -->
                <div
                    class="d-none d-lg-block"
                    :class="
                        prop_readonly
                            ? 'bandeja-66-techo_readonly'
                            : 'bandeja-66-techo'
                    "
                ></div>

                <!--  techo mobile -->
                <div class="bandeja-66-techo-mobile d-block d-lg-none"></div>
                <!-- ------ -->

                <div
                    class="bandeja-66-row d-flex flex-row"
                    v-for="row in multiLevel.rows"
                    :key="'row' + row"
                >
                    <div
                        v-if="!prop_readonly"
                        class="bandeja-66-item-parameters d-none d-lg-block"
                    >
                        <div v-if="multiLevel.existsElement(row, 1)">
                            <main-element66-edit-parameters-component
                                :mainElement="multiLevel.getElement(row, 1)"
                                @change="refreshParameters()"
                                @beforeUpdate="beforeUpdateParameter"
                                @afterUpdate="afterUpdateParameter"
                            />
                        </div>
                    </div>

                    <!-- COLUMNA 1 -->
                    <div class="bandeja-66-item-box">
                        <main-element66-component
                            v-if="multiLevel.existsElement(row, 1)"
                            :mainElement="multiLevel.getElement(row, 1)"
                            :dontShowTextParams="false"
                            :inverted="true"
                            :elementName="'#id_' + row + '-1'"
                        />

                        <div
                            v-if="!prop_readonly"
                            class="bandeja-66-item-buttons"
                            style="left: 0"
                        >
                            <!-- EDIT BUTTON -->
                            <button
                                v-if="multiLevel.existsElement(row, 1)"
                                @click="
                                    showModalParameters(
                                        row,
                                        1,
                                        row + '_loading_edit_left'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded d-block d-lg-none btn_size"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_edit_left'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-edit fa-sm"></i>
                            </button>

                            <!-- ADD BUTTON -->
                            <button
                                v-if="!multiLevel.existsElement(row, 1)"
                                @click="
                                    addElement(
                                        row,
                                        1,
                                        row + '_loading_add_left'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded btn_size"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_add_left'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-plus fa-sm"></i>
                            </button>
                            <!-- REMOVE BUTTON -->
                            <button
                                v-if="multiLevel.canRemoveElement(row, 1)"
                                @click="
                                    removeElement(
                                        row,
                                        1,
                                        row + '_loading_remove_left'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded btn_size"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_remove_left'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-minus fa-sm"></i>
                            </button>
                        </div>
                    </div>

                    <!-- perfil desktop -->
                    <div
                        :style="'top: ' + (row - 1) * 200 + 'px'"
                        class="d-none d-lg-block"
                        :class="
                            prop_readonly
                                ? 'bandeja-66-perfil_readonly'
                                : 'bandeja-66-perfil'
                        "
                    ></div>

                    <!-- perfil mobile -->
                    <div
                        :style="'top: ' + (row - 1) * 200 + 'px'"
                        class="bandeja-66-perfil-mobile d-block d-lg-none"
                    ></div>

                    <!-- COLUMNA 2 -->
                    <div class="bandeja-66-item-box">
                        <main-element66-component
                            v-if="multiLevel.existsElement(row, 2)"
                            :mainElement="multiLevel.getElement(row, 2)"
                            :dontShowTextParams="false"
                            :elementName="'#id_' + row + '-2'"
                        />

                        <div
                            v-if="!prop_readonly"
                            class="bandeja-66-item-buttons"
                            style="right: 0"
                        >
                            <!-- EDIT BUTTON -->
                            <button
                                v-if="multiLevel.existsElement(row, 2)"
                                @click="
                                    showModalParameters(
                                        row,
                                        2,
                                        row + '_loading_edit_right'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded d-block d-lg-none"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_edit_right'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-edit fa-sm"></i>
                            </button>

                            <!-- ADD BUTTON -->
                            <button
                                v-if="!multiLevel.existsElement(row, 2)"
                                @click="
                                    addElement(
                                        row,
                                        2,
                                        row + '_loading_add_right'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded btn_size"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_add_right'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-plus fa-sm"></i>
                            </button>
                            <!-- REMOVE BUTTON -->
                            <button
                                v-if="multiLevel.canRemoveElement(row, 2)"
                                @click="
                                    removeElement(
                                        row,
                                        2,
                                        row + '_loading_remove_right'
                                    )
                                "
                                class="btn btn-outline-secondary btn_rounded btn_size"
                            >
                                <i
                                    v-if="
                                        buttonsLoading[
                                            row + '_loading_remove_right'
                                        ]
                                    "
                                    class="fa fa-spinner fa-spin"
                                ></i>
                                <i v-else class="fas fa-minus fa-sm"></i>
                            </button>
                        </div>
                    </div>

                    <div
                        v-if="!prop_readonly"
                        class="bandeja-66-item-parameters d-none d-lg-block"
                    >
                        <div v-if="multiLevel.existsElement(row, 2)">
                            <main-element66-edit-parameters-component
                                :mainElement="multiLevel.getElement(row, 2)"
                                @change="refreshParameters()"
                                @beforeUpdate="beforeUpdateParameter"
                                @afterUpdate="afterUpdateParameter"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!prop_readonly" class="buttons_add_remove_rows">
                <!-- REMOVE ROW -->
                <button
                    class="btn btn-outline-secondary btn_rounded mt-3 btn_size"
                    :class="isMobile ? 'ml-2' : ''"
                    v-if="multiLevel.canRemoveRow()"
                    @click="multiLevel.removeRow()"
                >
                    <i
                        v-if="buttonsLoading['remove_row']"
                        class="fa fa-spinner fa-spin"
                    ></i>
                    <i v-else class="fas fa-arrow-up fa-sm"></i>
                </button>

                <!-- ADD ROW -->
                <button
                    class="btn btn-outline-secondary btn_rounded mt-3 btn_size"
                    :class="isMobile ? 'mr-2' : ''"
                    v-if="multiLevel.canAddRow()"
                    @click="multiLevel.addRow()"
                >
                    <i class="fas fa-arrow-down fa-sm"></i>
                </button>
            </div>

            <!-- diagnostics -->
            <diagnostics-component v-if="!prop_readonly" />

            <!-- MODAL PARAMETERS -->
            <div
                class="modal"
                tabindex="-1"
                role="dialog"
                ref="modal"
                v-if="elementSelected != null && !prop_readonly"
            >
                <div class="modal-dialog modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <i v-if="app.isProcessing" class="fa fa-spinner fa-spin mr-2"></i>
                                {{
                                    $t(
                                        "popup_parameters_small_screen_multilevel"
                                    )
                                }}
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-bs-dismiss="modal"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div
                            v-if="elementSelected"
                            class="modal-body d-flex flex-column align-items-center justify-content-center"
                        >
                            <!-- PARAMS -->
                            <main-element66-edit-parameters-component
                                :mainElement="elementSelected"
                                @change="refreshParameters()"
                                @beforeUpdate="beforeUpdateParameter"
                                @afterUpdate="afterUpdateParameter"
                            />
                            <!-- IMATGE -->
                            <main-element66-component
                                :mainElement="elementSelected"
                                :dontShowTextParams="true"
                            />
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                                data-dismiss="modal"
                            >
                                {{ $t("popup_cerrar_small_screen_multilevel") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.modal-mobile {
    max-width: 100% !important;
    width: 100% !important;
    position: fixed !important;
    bottom: 0 !important;
}
@media screen and (max-width: 480px) {
    .buttons_add_remove_rows,
    .bandeja-66-grid {
        zoom: 0.75;
    }
}

@media screen and (max-width: 330px) {
    .buttons_add_remove_rows,
    .bandeja-66-grid {
        zoom: 0.69;
    }
}
.btn_size {
    width: 42px;
    height: 42px;
}
.bandeja-66-row {
    height: 200px;
    overflow: hidden;
}
.bandeja-66-item-box,
.bandeja-66-item-parameters {
    width: 200px;
    height: 200px;
    float: left;
    clear: none;
    position: relative;
    overflow: hidden;
}
.bandeja-66-item-parameters {
    select {
        width: 160px !important;
    }
    padding: 20px;
}
.bandeja-66-item-buttons {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    height: 100%;
    width: 42px;
    button {
        width: 42px;
        height: 42px;
    }
}

.left_params_bandeja_col1 {
    position: absolute;
    left: 80px;
}

.left_params_bandeja_col2 {
    position: absolute;
    left: 235px;
}

.left_params_bandeja_col1_mobile {
    position: absolute;
    left: 80px;
}

.left_params_bandeja_col2_mobile {
    position: absolute;
    left: 235px;
}

.bandeja-66-techo {
    background-image: url("../../assets/images/gamas/66/pared_20x200.png");
    background-repeat: repeat-y;
    height: 400px;
    position: absolute;
    width: 20px;
    top: -210px;
    left: 390px;
    transform: rotate(90deg);
    z-index: 500;
}

.bandeja-66-techo-mobile,
.bandeja-66-techo_readonly {
    background-image: url("../../assets/images/gamas/66/pared_20x200.png");
    background-repeat: repeat-y;
    height: 400px;
    position: absolute;
    width: 20px;
    top: -210px;
    left: 190px;
    transform: rotate(90deg);
    z-index: 500;
}

.bandeja-66-perfil {
    background-image: url("../../assets/images/gamas/66/perfil_pared_20x200.png");
    background-repeat: repeat-x;
    height: 200px;
    position: absolute;
    width: 20px;
    left: 390px;
    transform: rotate(0deg);
    z-index: 500;
}

.bandeja-66-perfil-mobile,
.bandeja-66-perfil_readonly {
    background-image: url("../../assets/images/gamas/66/perfil_pared_20x200.png");
    background-repeat: repeat-x;
    height: 200px;
    position: absolute;
    width: 20px;
    left: 190px;
    transform: rotate(0deg);
    z-index: 500;
}
</style>

<script>
import jQuery from "jquery";
import Vue from "vue";
import { app } from "../../application.js";
import  Helper from "../../services/b66b67helper.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElementsGenericComponent from "./mainElementsGeneric.vue";
import mainElement66Component from "./mainElement66.vue";
import mainElement66EditParametersComponent from "./mainElement66EditParameters.vue";
// import { MultiLevel } from "@/services/multiLevel.js";
import { Fragment } from "vue-fragment";
import diagnosticsComponent from "../common/diagnostics.vue";

export default {
    extends: mainElementsGenericComponent,
    name: "mainElements66simetricComponent",
    props: {
        prop_readonly: false
    },
    data() {
        return {
            app: app,
            helper: new Helper(app),
            rows: 1,
            columns: 2,
            multiLevel: app.multiLevelHelper,
            elementSelected: null,
            elementSelectedRow: null,
            elementSelectedColumn: null,
            inlineParameterEdit: true,
            buttonsLoading: [],
            window: { width: 0, height: 0 }
        };
    },
    components: {
        editParameterValueComponent,
        mainElementsGenericComponent,
        mainElement66Component,
        mainElement66EditParametersComponent,
        Fragment,
        diagnosticsComponent
    },
    async created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        width_params: function () {
            if (this.isMobile) {
                return "200px";
            } else {
                return "160px";
            }
        },
        isMobile: function () {
            let a = this.window.width < 750;
            return a;
        }
    },

    methods: {
        getMainElement(row, col) {
            return this.multiLevel.getElement(row, col);
        },
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        addElement: async function (row = null, column = null, key = null) {
            var self = this;
            Vue.set(self.buttonsLoading, key, 1);
            await this.helper.resetDistanciaSoportes();
            await this.multiLevel.addElement(row, column);
            await this.helper.showCurrentDistanciaSoportes();
            Vue.set(self.buttonsLoading, key, 0);
        },
        removeElement: async function (row = null, column = null, key = null) {
            if (
                await app.asyncModal(
                    app.translate("popup_S3_remove_element_warning"),
                    true
                )
            ) {
                //console.log("OK");
                var self = this;
                Vue.set(self.buttonsLoading, key, 1);
                await this.helper.resetDistanciaSoportes();
                await this.multiLevel.removeElement(row, column);
                await this.app.asyncProcess(false, false);
                await this.helper.showCurrentDistanciaSoportes();
                Vue.set(self.buttonsLoading, key, 0);
            }

        },
        refreshParameters: async function (value) {
            // Unex.warn("Update parameter")
            await this.app.asyncProcess(false, false);
            // Unex.warn("Async process done")
            // Workaround element key=1
            if (this.multiLevel.existsKey("1")) {
                await this.multiLevel.removeElementByKey("1");
            }
            this.refreshElementSelected();
        },

        /**
         * Binds events to Helper
         */
        beforeUpdateParameter: async function (param, value) {
            await this.helper.beforeUpdateParameter(param,value)
        },
        afterUpdateParameter: async function (param, value) {
            await this.helper.afterUpdateParameter(param,value)
        },

        refreshElementSelected: function () {
            if (this.elementSelectedRow) {
                this.elementSelected = this.multiLevel.getElement(
                    this.elementSelectedRow,
                    this.elementSelectedColumn
                );
            }
        },
        showModalParameters: function (row, column) {
            this.elementSelectedRow = row;
            this.elementSelectedColumn = column;
            this.refreshElementSelected();

            // Wait till dom update
            this.$nextTick(() => {
                let modal = this.$refs.modal;
                jQuery(modal).modal("show");
            });
        }
    },
    beforeMount() { }
};
</script>

